/*
 * Purpose: Parse KEY=value paste blocks into vault secret names
 * Last modified: 2026-06-25 | Agent
 * Completeness: 95
 */

const NAME_ALIASES: Record<string, string> = {
  LINKEDIN_SECRET: 'LINKEDIN_CLIENT_SECRET',
  LINKEDIN_CLIENT_SECRET: 'LINKEDIN_CLIENT_SECRET',
  GOOGLE_CLIENT_ID: 'GOOGLE_CLIENT_ID',
  VITE_GOOGLE_CLIENT_ID: 'GOOGLE_CLIENT_ID',
  VITE_OPENAI_API_KEY: 'OPENAI_API_KEY',
  OPENAI_API_KEY: 'OPENAI_API_KEY',
  LINKEDIN_CLIENT_ID: 'LINKEDIN_CLIENT_ID',
  VITE_LINKEDIN_CLIENT_ID: 'LINKEDIN_CLIENT_ID',
};

export function normalizeSecretName(raw: string): string {
  const trimmed = raw.trim().toUpperCase();
  return NAME_ALIASES[trimmed] ?? trimmed;
}

export function parseSecretsPaste(text: string): Array<{ name: string; value: string }> {
  const out: Array<{ name: string; value: string }> = [];
  const seen = new Set<string>();

  for (const line of text.split('\n')) {
    const trimmed = line.trim();
    if (!trimmed || trimmed.startsWith('#')) continue;
    const eq = trimmed.indexOf('=');
    if (eq <= 0) continue;
    const rawName = trimmed.slice(0, eq).trim();
    let value = trimmed.slice(eq + 1).trim();
    if (
      (value.startsWith('"') && value.endsWith('"')) ||
      (value.startsWith("'") && value.endsWith("'"))
    ) {
      value = value.slice(1, -1);
    }
    if (!value) continue;
    const name = normalizeSecretName(rawName);
    if (seen.has(name)) continue;
    seen.add(name);
    out.push({ name, value });
  }
  return out;
}
